module.exports = __webpack_public_path__ + "media/compress_video.01116c6a.mp4";